import React from 'react';
import { Link } from 'react-router-dom';

const Ticket = (props) => {
    return (
        <Link to={`/Tickets/InnerPage/${props.id}`} className="ticket">

            <div className="title">
                <span>{props.title}</span>
            </div>
            <span className="date">{props.date}</span>
            <div className="number">
                <span>شماره تیکت : <b>{props.number}</b></span>
                
            <span 
                  className={`${ 
                    props.status === 'open' 
                    ? "open"
                    : "closed"
                    }`}
                >{props.statusMessage}</span>
            </div>
        </Link>
    );
}

export default Ticket;